// Mock data for 3strand Cord Ministry

export const navigationItems = [
  {
    name: 'Darkness',
    href: '#darkness',
    submenu: [
      { name: 'Land', href: '#land', description: 'Exploring the spiritual landscape' },
      { name: 'People', href: '#people', description: 'Understanding those in darkness' }
    ]
  },
  {
    name: 'Issues',
    href: '#issues',
    submenu: [
      { name: 'Physical Pain', href: '#physical-pain', description: 'Healing for the body' },
      { name: 'Emotional Trauma', href: '#emotional-trauma', description: 'Restoration for the heart' },
      { name: 'Depression', href: '#depression', description: 'Hope in the darkness' }
    ]
  },
  {
    name: 'Where I Am',
    href: '#where-i-am',
    submenu: [
      { name: 'Just Curious', href: '#curious', description: 'Exploring faith' },
      { name: 'Agnostic', href: '#agnostic', description: 'Seeking answers' },
      { name: 'Feeling God Exists', href: '#sensing', description: 'Beginning to believe' },
      { name: 'New Believer', href: '#new-believer', description: 'Fresh in faith' },
      { name: 'Seasoned Believer', href: '#seasoned', description: 'Growing deeper' },
      { name: 'Minister', href: '#minister', description: 'Called to serve' }
    ]
  },
  {
    name: 'Personal',
    href: '#personal',
    submenu: [
      { name: 'Spiritual', href: '#spiritual', description: 'Nurturing your spirit' },
      { name: 'Body', href: '#body', description: 'Temple of the Holy Spirit' },
      { name: 'Soul', href: '#soul', description: 'Mind, will, and emotions' },
      { name: 'Family', href: '#family', description: 'Building godly households' }
    ]
  },
  {
    name: 'Spheres',
    href: '#spheres',
    submenu: [
      { name: 'Work', href: '#work', description: 'Faith in the workplace' },
      { name: 'Business', href: '#business', description: 'Kingdom entrepreneurship' },
      { name: 'Ministry', href: '#ministry', description: 'Serving others' },
      { name: 'Investments', href: '#investments', description: 'Stewardship wisdom' },
      { name: 'Resources', href: '#resources', description: 'Tools for growth' }
    ]
  },
  {
    name: 'Topics',
    href: '#topics',
    submenu: [
      { name: 'Meditation', href: '#meditation', description: 'Dwelling in His presence' },
      { name: 'Prayer', href: '#prayer', description: 'Communion with God' },
      { name: 'Angels', href: '#angels', description: 'Heavenly messengers' },
      { name: '7 Pillars of Wisdom', href: '#wisdom', description: 'Foundations of understanding' },
      { name: 'Power', href: '#power', description: 'Walking in authority' }
    ]
  }
];

export const heroContent = {
  badge: 'Join Our Community • Start Your Journey Today',
  headline: 'Spiritual infrastructure to strengthen your faith',
  subheadline: 'Join thousands who have discovered deeper connection with God through 3strand Cord. We provide resources for spiritual growth, healing, and purposeful living.',
  primaryCta: 'Begin Journey',
  secondaryCta: 'Explore Resources'
};

export const statsData = [
  { value: '10K+', label: 'Lives transformed' },
  { value: '99.9%', label: 'Commitment to truth' },
  { value: '50+', label: 'Countries reached' },
  { value: '24/7', label: 'Prayer support available' }
];

export const featuredSections = [
  {
    id: 'darkness',
    title: 'Understanding Darkness',
    description: 'Explore the spiritual landscape and understand those walking in darkness. Find light for every situation.',
    features: [
      { name: 'Land', description: 'Navigate spiritual territories with wisdom and discernment.' },
      { name: 'People', description: 'Learn to minister effectively to those seeking truth.' }
    ],
    color: 'from-slate-900 to-purple-900'
  },
  {
    id: 'issues',
    title: 'Addressing Life\'s Challenges',
    description: 'Find healing, hope, and restoration for physical, emotional, and mental struggles.',
    features: [
      { name: 'Physical Pain', description: 'Biblical principles for health and healing.' },
      { name: 'Emotional Trauma', description: 'Inner healing and restoration of the soul.' },
      { name: 'Depression', description: 'Finding hope and purpose in difficult seasons.' }
    ],
    color: 'from-blue-600 to-indigo-700'
  },
  {
    id: 'journey',
    title: 'Meet You Where You Are',
    description: 'Wherever you are on your spiritual journey, we have resources tailored for you.',
    features: [
      { name: 'Curious', description: 'Safe space to explore questions about faith.' },
      { name: 'Agnostic', description: 'Honest dialogue about life\'s biggest questions.' },
      { name: 'New Believer', description: 'Strong foundations for your new faith.' },
      { name: 'Seasoned Believer', description: 'Deeper revelations and growth.' },
      { name: 'Minister', description: 'Equipping for effective service.' }
    ],
    color: 'from-emerald-600 to-teal-700'
  }
];

export const personalGrowth = [
  {
    title: 'Spiritual',
    description: 'Develop intimacy with God through prayer, worship, and meditation.',
    icon: 'Heart'
  },
  {
    title: 'Body',
    description: 'Honor God with your physical temple through biblical health principles.',
    icon: 'Activity'
  },
  {
    title: 'Soul',
    description: 'Renew your mind, align your will, and heal your emotions.',
    icon: 'Brain'
  },
  {
    title: 'Family',
    description: 'Build strong, godly households that impact generations.',
    icon: 'Users'
  }
];

export const spheresOfInfluence = [
  {
    title: 'Work',
    description: 'Integrate faith into your career and be salt and light.',
    stats: 'Kingdom Impact'
  },
  {
    title: 'Business',
    description: 'Build enterprises with biblical principles and eternal purpose.',
    stats: 'Eternal ROI'
  },
  {
    title: 'Ministry',
    description: 'Discover and fulfill your calling to serve others.',
    stats: 'Lives Touched'
  },
  {
    title: 'Investments',
    description: 'Steward resources wisely for kingdom advancement.',
    stats: 'Faithful Stewardship'
  },
  {
    title: 'Resources',
    description: 'Access tools and materials for every area of growth.',
    stats: 'Equipped Saints'
  }
];

export const topicsContent = [
  {
    name: 'Meditation',
    description: 'Learn to quiet your mind and hear God\'s voice through biblical meditation.',
    verse: 'Be still and know that I am God - Psalm 46:10'
  },
  {
    name: 'Prayer',
    description: 'Develop a powerful prayer life that moves mountains.',
    verse: 'The prayer of a righteous person is powerful and effective - James 5:16'
  },
  {
    name: 'Angels',
    description: 'Understand the ministry of angels and their role in your life.',
    verse: 'Are they not all ministering spirits? - Hebrews 1:14'
  },
  {
    name: '7 Pillars of Wisdom',
    description: 'Build your life on the seven pillars that wisdom has established.',
    verse: 'Wisdom has built her house; she has set up its seven pillars - Proverbs 9:1'
  },
  {
    name: 'Power',
    description: 'Walk in the authority and power given to believers.',
    verse: 'You will receive power when the Holy Spirit comes on you - Acts 1:8'
  }
];

export const testimonials = [
  {
    quote: '3strand Cord helped me find healing from years of emotional trauma. The resources and community support changed my life.',
    author: 'Sarah M.',
    role: 'New Believer'
  },
  {
    quote: 'As a minister, the depth of teaching here has equipped me to better serve my congregation.',
    author: 'Pastor James K.',
    role: 'Church Leader'
  },
  {
    quote: 'I came as an agnostic with questions. I found answers and a community that welcomed my journey.',
    author: 'Michael T.',
    role: 'Seeker to Believer'
  }
];

export const ctaContent = {
  title: 'Ready to strengthen your faith?',
  description: 'Join 3strand Cord today and access resources designed to help you grow spiritually, find healing, and live purposefully.',
  primaryCta: 'Start Your Journey',
  secondaryCta: 'Contact Us'
};

export const footerLinks = {
  ministry: [
    { name: 'About Us', href: '#about' },
    { name: 'Our Mission', href: '#mission' },
    { name: 'Leadership', href: '#leadership' },
    { name: 'Events', href: '#events' }
  ],
  resources: [
    { name: 'Articles', href: '#articles' },
    { name: 'Videos', href: '#videos' },
    { name: 'Podcasts', href: '#podcasts' },
    { name: 'Books', href: '#books' }
  ],
  connect: [
    { name: 'Prayer Request', href: '#prayer' },
    { name: 'Join Community', href: '#community' },
    { name: 'Volunteer', href: '#volunteer' },
    { name: 'Give', href: '#give' }
  ],
  legal: [
    { name: 'Privacy', href: '#privacy' },
    { name: 'Terms', href: '#terms' },
    { name: 'Contact', href: '#contact' }
  ]
};
